import React from "react";
import {
    Box,
    Typography,
    Avatar,
    Paper,
    Divider,
    Stack,
    IconButton,
} from "@mui/material";
import { useGetInvoiceCommentListQuery } from "store/slices/apis/invoiceApiSlice";
import moment from "moment";
import { useParams } from "react-router-dom";


function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */

    for (i = 0; i < string?.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

function stringAvatar(name) {
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${name?.split(' ')?.[0]?.[0]}`,
    };
}

const InvoiceCommentList = (props) => {
    const { data } = props;
    const { projectId } = useParams();
    const getInvoiceCommentList = useGetInvoiceCommentListQuery({ ProjectId: projectId, invoiceId: data?.invoiceApprovalId });

    const validComments =
        getInvoiceCommentList?.data?.data?.filter(
            (c) => c?.comments && c.comments.trim() !== ""
        ) || [];

    return (
        <Box
            sx={{

                mx: "auto",
                // mt: 4,
                display: "flex",
                flexDirection: "column",
                gap: 2,
            }}
        >

            {validComments.length > 0 ?
                validComments.map((comment) => (
                    <Paper
                        key={comment.invoiceApprovalCommentId}
                        elevation={0}
                        sx={{
                            p: 2,
                            border: "1px solid #e0e0e0",
                            borderRadius: 2,
                            backgroundColor: "#fafafa",
                        }}
                    >
                        {/* Header */}
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Avatar {...stringAvatar(comment?.commentBy)} />
                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                    {comment?.commentBy}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {moment(comment?.createdDate)?.format('LLL')}
                                </Typography>
                            </Box>
                        </Stack>
                        <Typography
                            variant="body2"
                            sx={{ mt: 1.5, color: "#333", lineHeight: 1.6, whiteSpace: "pre-line" }}
                        >
                            {comment?.comments}
                        </Typography>
                    </Paper>
                ))
                : 
                (
                    <Typography
                        variant="body2"
                        sx={{ mt: 1.5, color: "#333", lineHeight: 1.6 }}
                    >
                        Comments not found.
                    </Typography>
                )

            }
        </Box>
    );
};

export default InvoiceCommentList;
